<template>
  <ckeditor></ckeditor>
</template>

<script>
  import { component as ckeditor } from '@mayasabha/ckeditor4-vue3'
  
  export default {
    name: 'InputEditor',
    components: {
      ckeditor,
    },

    data() {
      return {
        // editor: null,
      }
    },

    mounted() {
      // this.editor = new Editor({
      //   content: "<p>I'm running Tiptap with Vue.js. 🎉</p>",
      //   extensions: [StarterKit],
      // })
      const config = ckeditor;

      config.removePlugins = ['codigo-fonte'];
      // $.fn.modal.Constructor.prototype._enforceFocus = function(){};
    },

    beforeUnmount() {
      // ckeditor.destroy()
    },
  }
</script>

<style scoped>
.ck {z-index: 9999 !important;}
</style>